import {Button} from '@/components/ui/button';
import {cn} from '@/lib/utils';
import {flexRender, type Header} from '@tanstack/react-table';
import {ArrowDownIcon, ArrowUpIcon, ChevronsUpDownIcon} from 'lucide-react';
import React from 'react';

interface Props<TData, TValue> extends React.HTMLAttributes<HTMLDivElement> {
  header: Header<TData, TValue>
}

const getTitle = (title: string) => {
  return <span className="text-accent-foreground font-bold">{title}</span>;
};

export function AppTableColumnHeader<TData, TValue>({header}: Props<TData, TValue>) {
  if (typeof header.column.columnDef.header !== 'string') {
    return flexRender(
      header.column.columnDef.header,
      header.getContext()
    );
  }
  return (
    <div className="flex flex-col">
      {header.column.columnDef.enableSorting && header.column.getCanSort() ? (
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-full px-0 justify-between"
          onClick={header.column.getToggleSortingHandler()}
        >
          <div className={cn('grow flex', header.column.columnDef.meta?.className)}>
            {getTitle(header.column.columnDef.header as string)}
          </div>
          {header.column.getIsSorted() === 'desc' ? (
            <ArrowDownIcon/>
          ) : header.column.getIsSorted() === 'asc' ? (
            <ArrowUpIcon/>
          ) : (
            <ChevronsUpDownIcon/>
          )}
        </Button>
      ) : (
        <div className={cn(
          'flex flex-col justify-center min-h-8',
          header.column.columnDef.meta?.className
        )}><span className="px-1">{getTitle(header.column.columnDef.header as string)}</span></div>
      )}
    </div>
  );

}